module.exports = __webpack_public_path__ + "img/man.b4d10eb1.png";